<!-- pass._master_pass.content.description_json.BeforeUseCaution -->
<template>
  <div class="text" v-html="newlineConvert(note)" />
</template>

<script>
export default {
  name: "MPMSFaceBeforeUseCaution",
  props: {
    note: {
      type: String,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  font-size: 14px;
  position: relative;
  top: 5vh;
  line-height: 24px;
}
</style>
